"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JRC20Asset = exports.JEVMGasToken = void 0;
const chain_1 = require("../chain");
const asset_1 = require("./asset");
const evm_1 = require("./evm");
/**
 * Representation of the gas token used to pay fees in an JEVM.
 * JEVM gas token also has a reference to its native JNT asset.
 * It is also known as the native asset of a JEVM.
 */
class JEVMGasToken extends evm_1.EVMGasToken {
    nativeAsset;
    constructor(nativeAsset) {
        super(nativeAsset.assetId, nativeAsset.name, nativeAsset.symbol);
        this.nativeAsset = nativeAsset;
    }
}
exports.JEVMGasToken = JEVMGasToken;
/**
 * Representation of a JRC20 smart contract.
 */
class JRC20Asset extends evm_1.ERC20Asset {
    type = asset_1.TokenType.JRC20;
    nativeAssetId;
    adapter;
    constructor(address, name, symbol, decimals, nativeAssetId) {
        super(address, name, symbol, decimals);
        this.nativeAssetId = nativeAssetId;
        this.adapter = new chain_1.JRC20ContractAdapter(address);
    }
}
exports.JRC20Asset = JRC20Asset;
